import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/utils/orsRouting";
// Layout compoents
import DefaultLayout from "./layouts/DefaultLayout";
import VueSocialSharing from 'vue-social-sharing'
import AuthLayout from "./layouts/AuthLayout";
import { BootstrapVue } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.component("defaultlayout", DefaultLayout);
Vue.component("loginlayout", AuthLayout);
// kendo native
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
Vue.use(VueSocialSharing);
Vue.component("k-input", Input);
Vue.component("numerictextbox", NumericTextBox);
Vue.component("grid-toolbar", GridToolbar);
Vue.component("grid-norecords", GridNoRecords);
Vue.component("Grid", Grid);
Vue.component("dropdownlist", DropDownList);
import OverSpeedReport from "@/components/ReportFilter/OverSpeedReport.vue"
import StopageViloationReport from "@/components/ReportFilter/StopageViloationReport.vue"
import IgnitionOnOffReport from "@/components/ReportFilter/IgnitionOnOffReport.vue"
import IdleDurationReport from "@/components/ReportFilter/IdleDurationReport.vue"
import DailyDistanceReport from "@/components/ReportFilter/DailyDistanceReport.vue"
import TravelPathReport from "@/components/ReportFilter/TravelPathReport.vue"
import CityGeofenceReport from "@/components/ReportFilter/CityGeofenceReport.vue"
import GeofenceInOutReport from "@/components/ReportFilter/GeofenceInOutReport.vue"
import GeofenceOutInReport from "@/components/ReportFilter/GeofenceOutInReport.vue"
import GeofenceBaseReport from "@/components/ReportFilter/GeofenceBaseReport.vue"
import VehicleReport from "@/components/ReportFilter/VehicleReport.vue"
import ImmobilizeReport from "@/components/ReportFilter/ImmobilizeReport.vue"

// Optionally install the BootstrapVue icon components plugin
// kendo wraper
import { GridColumn, GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { ButtonsInstaller } from "@progress/kendo-buttons-vue-wrapper";
import { DateinputsInstaller } from "@progress/kendo-dateinputs-vue-wrapper";
import { DataSourceInstaller } from "@progress/kendo-datasource-vue-wrapper";
import { LayoutInstaller, TabStrip } from "@progress/kendo-layout-vue-wrapper";
import { WindowInstaller } from "@progress/kendo-window-vue-wrapper";
import { PopupsInstaller } from "@progress/kendo-popups-vue-wrapper";
import { SchedulerInstaller } from "@progress/kendo-scheduler-vue-wrapper";
import { InputsInstaller } from "@progress/kendo-inputs-vue-wrapper";
import { DropdownsInstaller } from "@progress/kendo-dropdowns-vue-wrapper";
import { ValidatorInstaller } from "@progress/kendo-validator-vue-wrapper";
import { DropDownTreeInstaller } from "@progress/kendo-dropdowntree-vue-wrapper";
import { UploadInstaller } from "@progress/kendo-upload-vue-wrapper";
import { DialogInstaller } from "@progress/kendo-dialog-vue-wrapper";
import * as L from 'leaflet';
import "@/lib/leaflet-moving-rotated-marker";

Vue.component("OverSpeedReport", OverSpeedReport);
Vue.component("IdleDurationReport", IdleDurationReport);
Vue.component("TravelPathReport", TravelPathReport);
Vue.component("DailyDistanceReport", DailyDistanceReport);
Vue.component("StopageViloationReport", StopageViloationReport);
Vue.component("IgnitionOnOffReport", IgnitionOnOffReport);
Vue.component("CityGeofenceReport",CityGeofenceReport);
Vue.component("GeofenceInOutReport",GeofenceInOutReport);
Vue.component("GeofenceOutInReport",GeofenceOutInReport);
Vue.component("GeofenceBaseReport",GeofenceBaseReport);
Vue.component("VehicleReport",VehicleReport);
Vue.component("ImmobilizeReport",ImmobilizeReport);
Vue.component('b-table', BTable)
Vue.component('b-pagination', BPagination)


Vue.use(DialogInstaller);
Vue.use(UploadInstaller);
// import { Chart, ChartSeriesItem, ChartInstaller } from '@progress/kendo-charts-vue-wrapper';
// Vue.use(ChartInstaller);
// Vue.use(Chart);
// Vue.use(ChartSeriesItem);
Vue.use(ValidatorInstaller);
Vue.use(DropdownsInstaller);
Vue.use(GridInstaller);
Vue.use(GridColumn);
Vue.use(WindowInstaller);
Vue.use(DataSourceInstaller);
Vue.use(ButtonsInstaller);
Vue.use(DateinputsInstaller);
Vue.use(LayoutInstaller);
Vue.use(PopupsInstaller);
Vue.use(TabStrip);
Vue.use(SchedulerInstaller);
Vue.use(InputsInstaller);
Vue.use(DropDownTreeInstaller);
// bootstrap vue components / bootstrap vue icon
import { IconsPlugin, BTable, BPagination, BootstrapVueIcons} from 'bootstrap-vue'
import { BFormCheckbox, BFormCheckboxGroup, BFormGroup } from "bootstrap-vue";
import { BNavItemDropdown } from "bootstrap-vue";
import { BDropdownItem } from "bootstrap-vue";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(BootstrapVueIcons)

Vue.component("b-nav-item-dropdown", BNavItemDropdown);
Vue.component("b-form-checkbox", BFormCheckbox);
Vue.component("b-form-checkbox-group", BFormCheckboxGroup);
Vue.component("b-form-group", BFormGroup);
Vue.component("b-dropdown-item", BDropdownItem);
// common css
import "./assets/scss/index.scss";

/* OIDC Store */
import { vuexOidcCreateStoreModule } from "vuex-oidc";
// import { oidcSettings } from '@/config/oidc'
import { getEnvironmentSettings, getOidcSettings } from "@/utils/oidc-heper";
Vue.config.productionTip = false;
Vue.filter("formatTime", function (value) {
  if (value) {
    return new Date(value).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
});

Vue.filter("formatDateTime", function (value) {
  let d = new Date(value);
  return (
    d.toLocaleDateString() +
    ", " +
    d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
});

Vue.filter("ListFormat", function (date) {
  let val = date.split("/").reverse().join('-');

  let localDate = val + 'T18:30:00.000Z'
  return new Date(localDate.toString()).toLocaleDateString()
});

//vue2leaflet
import 'leaflet/dist/leaflet.css';
delete L.Icon.Default.prototype._getIconUrl
// eslint-disable-next-line  
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';
Vue.component('v-marker-cluster', Vue2LeafletMarkerCluster);


getEnvironmentSettings().then(async (settings) => {
  // Prefetch Application Settings and Set to State
  await store.commit("setSettings", settings);
  const settingsOidc = await getOidcSettings(settings.oidc);
  await store.registerModule(
    "oidcStore",
    vuexOidcCreateStoreModule(
      settingsOidc,
      { namespaced: true },
      {
        userLoaded: function (user) { console.log("OIDC user is loaded:", user) },
        userUnloaded: () => console.log("OIDC user is unloaded"),
        accessTokenExpiring: () => console.log("Access token will expire"),
        accessTokenExpired: () => {
          console.log("Access token did expire");
          store.dispatch("oidcStore/signOutOidc");
        },
        silentRenewError: () =>
          console.log("OIDC user is unloaded - silentRenewError"),
        userSignedOut: () => console.log("OIDC user is signed out"),
        oidcError: (payload) =>
          console.log(`An error occured at ${payload.context}:`, payload.error),
      }
    )
  );

  //Start the application
  new Vue({
    store,
    router,
    render: (h) => h(App),
  }).$mount("#app");
});
